import React,{ useState, useEffect } from 'react';
import { getList } from '../../../common/v4/BackendProvider';
import ReactApexChart from 'react-apexcharts';

    const options1 = {
            title: {
                    text: 'Calls',
                    align: 'left',
                    style: {
                        fontSize: '14px'
                    }
                },
            tooltip: {
                x: {
                  format: 'yyyy-MM-dd HH'
                }
              },
            chart: {
                
                id: 'calls',
                group: 'voice',
                type: 'line',
                height: 80
            },
            colors: ['#008FFB'],
            xaxis: {
                type: 'datetime',
                format: 'HH:mm',
                tickAmount: 6,
            },
            yaxis: {
                labels: {
                    formatter: function(value) {
                        return value.toFixed(0);
                    },
                }
            }
        };
       

    const options2 = {
        title: {
            text: 'ASR %',
            align: 'left',
            style: {
                fontSize: '14px'
            }
        },
        tooltip: {
                x: {
                  format: 'yyyy-MM-dd HH'
                }
              },
            chart: {
                id: 'asr',
                group: 'voice',
                type: 'line',
                height: 80
            },
            colors: ['#00E396'],
            xaxis: {
                type: 'datetime',
                format: 'HH:mm',
                tickAmount: 6,
            },
            yaxis: {
                labels: {
                    formatter: function(value) {
                        return value.toFixed(2);
                    }
                }
            }
        };
    const options3 = {
        title: {
            text: 'ACD (min)',
            align: 'left',
            style: {
                fontSize: '14px'
            }
        },
        tooltip: {
            x: {
                format: 'yyyy-MM-dd HH'
            }
        },
        chart: {
            id: 'acd',
            group: 'voice', 
            type: 'line',
            height: 80
        },
        colors: ['#FEB019'],
        xaxis: {
            type: 'datetime',
            format: 'HH:mm',
            tickAmount: 6,
        },
        yaxis: {
            labels: {
                formatter: function(value) {
                    return value.toFixed(1);
                }
            }
        }
    };

    const options4 = {
        title: {
            text: 'Minutes (per hour)',
            align: 'left',
            style: {
                fontSize: '14px'
            }
        },
        tooltip: {
            x: {
                format: 'yyyy-MM-dd HH'
            }
        },
        chart: {
            id: 'seconds',
            group: 'voice',
            type: 'line',
            height: 80
        },
        colors: ['#FF4560'],
        xaxis: {
            type: 'datetime',
            format: 'HH:mm',
            tickAmount: 6,
        },
        yaxis: {
            labels: {
                formatter: function(value) {
                    return Math.round(value);
                }
            }
        }
    };


const VoiceChart = () => {
    const [data, setData] = useState([]);
    const [state, setState] = useState({series1: [], series2: [], series3: [], series4: []});

    useEffect(() => {
        getList('/admin/dashboard/voice-chart').then(
            response => {
                setData(response.data.data);
                setState({
                    series1: [{
                        name: 'Calls',
                        data: response.data.data.map(item => [
                            new Date(item.timestamp).getTime()*1000,
                            item.calls
                        ])
                    }],             
                    series2: [{
                        name: 'ASR',
                        data: response.data.data.map(item => [
                            new Date(item.timestamp).getTime()*1000,
                            item.asr
                        ])
                    }],
                    series3: [{
                        name: 'ACD',
                        data: response.data.data.map(item => [
                            new Date(item.timestamp).getTime()*1000,
                            item.acd
                        ])
                    }],
                    series4: [{
                        name: 'Minutes',
                        data: response.data.data.map(item => [
                            new Date(item.timestamp).getTime()*1000,
                            item.minutes
                        ])
                    }]
                });
            }
        ).catch(error => {
            console.error('Error fetching voice chart data:', error);
        });
    }, []);

    return (
        <div>
            <ReactApexChart
                type="line"
                height={160}
                series={state.series1}
                options={options1}
            />
            <ReactApexChart
                type="line"
                height={160}
                series={state.series4}
                options={options4}
            />
            <ReactApexChart
                type="line"
                height={160}
                series={state.series2}
                options={options2}
            />
            <ReactApexChart
                type="line"
                height={160}
                series={state.series3}
                options={options3}
            />
        </div>
    );
};

export default VoiceChart;